import { cn } from "@bem-react/classname"
import { getCatalog, getType, selectCatalog, setCatalog } from "modules/Catalog"
import { FC } from "react"
import { useDispatch, useSelector } from "react-redux"
import "./CatalogSelector.scss"

const CatalogSelector: FC = () => {
    const dispatch = useDispatch()
    const data = useSelector(selectCatalog)
    const setCat = (name:string) => ()=>dispatch(setCatalog(name))
    const catType = getType(data)
    const catalog = getCatalog(data)
    const cnCatSel = cn('CatalogSelector')
    if (!catType){
        return <></>
    }
    if (catType.catalogs.length === 1){
        return <></>
    }
    const catalogs = catType?catType.catalogs:[]
    return <div className={cnCatSel()}>
        {catalogs.map((el, index) => 
            <span key={index} onClick={setCat(el.name)} className={catalog?.name === el.name? "active":""}>
                {el.title}
            </span>)}
    </div>
}

export default CatalogSelector